import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

import { CUSTOMERIO_SITE_ID, CUSTOMERIO_WRITE_KEY } from "./env";

const hasRequiredCredentials = CUSTOMERIO_WRITE_KEY.length > 0 && CUSTOMERIO_SITE_ID.length > 0;

type InAppEvent = {
    type: string;
    detail?: {
        deliveryId?: string;
        messageId?: string;
        actionName?: string;
        actionValue?: string;
    };
};

const analytics = hasRequiredCredentials
    ? AnalyticsBrowser.load(
          {
              writeKey: CUSTOMERIO_WRITE_KEY,
              cdnURL: "https://cdp-eu.customer.io",
          },
          {
              integrations: {
                  "Customer.io In-App Plugin": {
                      siteId: CUSTOMERIO_SITE_ID,
                      events: (event: InAppEvent) => {
                          switch (event.type) {
                              case "in-app:message-opened":
                              case "in-app:message-dismissed":
                              case "in-app:message-action":
                              case "in-app:message-error":
                              case "in-app:message-changed":
                                  console.info("[customer.io]", event.type, event.detail);
                                  break;
                              default:
                                  break;
                          }
                      },
                  },
              },
          } as never,
      )
    : null;

if (!hasRequiredCredentials) {
    console.info("[customer.io] disabled", {
        hasWriteKey: CUSTOMERIO_WRITE_KEY.length > 0,
        hasSiteId: CUSTOMERIO_SITE_ID.length > 0,
    });
}

export function customerIoPage() {
    if (!analytics) return;
    analytics.page();
}

export function customerIoIdentify(userId: string, traits?: Record<string, unknown>) {
    if (!analytics) return;
    analytics.identify(userId, traits);
}

export function customerIoReset() {
    if (!analytics) return;
    analytics.reset();
}
